export const decode = (string) => {
    if( typeof document !== "object" ) {
        return string
    }
    
    let doc = document.createElement('textarea') 
    doc.innerHTML = string 

    const value = doc.value
    doc = null
    
    return value
}

export const truncate = (string, length) => {
    return string.substring(0, length);
}

export const stripTags = (string) => {
    if( typeof document !== "object" ) {
        return string
    }

    let div = document.createElement('div')
    div.innerHTML = string
    const stripped = div.textContent || div.innerText || string
    div = null

    return stripped
}